import { useMediaQuery, useTheme } from '@mui/material';

type ThemeMediaQuery = {
  small: boolean;
  medium: boolean;
  large: boolean;
};

const useThemeMediaQuery = (): ThemeMediaQuery => {
  const bpFunc = useTheme().breakpoints.down;

  return {
    small: useMediaQuery(bpFunc('sm')),
    medium: useMediaQuery(bpFunc('md')),
    large: useMediaQuery(bpFunc('lg')),
  };
};

export default useThemeMediaQuery;
